import { Tabs } from "antd";
import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { WITHIN_TABS_STATE } from "../../hooks/useWithinTabs";

const { TabPane } = Tabs;

export const VAT_TABS = {
  VAT: {
    key: "VAT",
    path: "/vat-view",
  },
  ELSTER: {
    key: "ELSTER",
    path: "/vat-view/elster",
  },
  SUBMISSIONS: {
    key: "Submissions",
    path: "/vat-view/submissions",
  },
  DFV: {
    key: "DFV",
    path: "/vat-view/dfv",
  },
};

const SubNavigation = ({ activeTab }: { activeTab: string }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const onChangeTab = useCallback(
    (key: string) => {
      const tab = Object.values(VAT_TABS).find((t) => t.key === key);
      if (tab)
        navigate(tab.path + location.search, { state: WITHIN_TABS_STATE });
    },
    [navigate, location.search]
  );

  return (
    <Tabs type="card" activeKey={activeTab} onChange={onChangeTab}>
      <TabPane tab={VAT_TABS.VAT.key} key={VAT_TABS.VAT.key} />
      <TabPane tab={VAT_TABS.ELSTER.key} key={VAT_TABS.ELSTER.key} />
      <TabPane tab={VAT_TABS.SUBMISSIONS.key} key={VAT_TABS.SUBMISSIONS.key} />
      <TabPane tab={VAT_TABS.DFV.key} key={VAT_TABS.DFV.key} />
    </Tabs>
  );
};

export default SubNavigation;
